var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-card',[_c('v-card-title',[_vm._v(" Личная информация ")]),_c('v-card-title',[_c('property-form',{attrs:{"value":_vm.user,"fields":[
                'email',
                'first_name',
                'last_name',
                'referral_code',
                'phone',
                'inn',
                'ogrn',
              ].reduce((a, v) => {
                a[v] = { visible: true };
                return a;
              }, {})},on:{"input":_vm.doUpdateUser}})],1)],1)],1),_c('v-col',[_c('v-card',[_c('v-card-title',[_vm._v(" Программа для формирования сессий ")]),_c('v-card-subtitle',[_vm._v(" Последняя версия от "),_c('b',[_vm._v("31/08/2023")])]),_c('v-card-text',[_c('v-list',[_c('v-list-item',[_c('a',{attrs:{"href":"/apps-76hyy1ehIa-12/app_1.3.21.09.34.zip"}},[_vm._v(" Скачать (Версия от 21.09.2023) ")])]),_c('v-list-item',[_c('a',{attrs:{"href":"/api/apps/v1.3.23.08.31"}},[_vm._v(" Скачать (Версия от 31.08.2023) ")])]),_c('v-list-item',[_c('a',{attrs:{"href":"/api/apps/v1.2.14.08.31"}},[_vm._v(" Скачать (Версия от 14.08.2023) ")])])],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }